import { Archive, CircleCheck, Lightbulb, Sparkles } from 'lucide-react'
import type { BottomNavItem } from '@/registry/types'

/**
 * Capture-only bottom nav:
 *
 *   [Inbox] [Acted] [Archive] [Review]
 *
 *   - Inbox    capture raw thoughts, the whole point of the app
 *   - Acted    ideas the user actually did something about — the record of
 *              what kinds of ideas are worth continuing to have
 *   - Archive  ideas whose energy faded (never deleted, always browsable)
 *   - Review   AI pass over the active stream: reflect, spot patterns,
 *              suggest what to archive — informed by the acted/faded history
 */
export const ideasBottomNav: BottomNavItem[] = [
  { id: 'inbox', label: 'Inbox', icon: Lightbulb, href: '/apps/ideas' },
  { id: 'acted', label: 'Acted', icon: CircleCheck, href: '/apps/ideas/acted' },
  { id: 'archive', label: 'Archive', icon: Archive, href: '/apps/ideas/archive' },
  { id: 'review', label: 'Review', icon: Sparkles, href: '/apps/ideas/review' },
]
